import { Image as ExpoImage } from 'expo-image';

type ImageProps = {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
};

const Image: React.FC<ImageProps> = ({
  src,
  alt,
  width,
  height,
  className,
}) => {
  return (
    <div className={className}>
      <ExpoImage
        source={{
          uri: src,
        }}
        style={{
          width,
          height,
        }}
        alt={alt}
      />
    </div>
  );
};

export { Image };
